
import styles from "../../ProductItem.module.css"


export const PayementSuccess = ({lang})=>{
    

    return <div>
      {
        lang=="lv"?<div>
          <div className="mt-5" style={{fontWeight:"bold",color:"#2c6b10",fontSize:32}}>Veiksmīgs pirkums !</div>
          <div className="mt-2" style={{fontWeight:"400",color:"#2c6b10",fontSize:22}}>Ar Jums sazināsies e-pastā</div>
        </div>:<div>
        <div className="mt-5" style={{fontWeight:"bold",color:"#2c6b10",fontSize:32}}>Thank you for purchase !</div>
        <div className="mt-2" style={{fontWeight:"400",color:"#2c6b10",fontSize:22}}>We will contact you soon</div>
        </div>
        
      }
          
            </div>
};

